<template>
  <div class="client_manage">
    <a-card title="客户管理" :bordered="false">

      <!-- 搜索 -->
      <div class="search">
        <a-form layout="inline" :form="form" @submit="handleQuerySubmit">

          <a-form-item>
            <a-input allowClear v-decorator="['mobile']" placeholder="请输入手机号码"></a-input>
          </a-form-item>
          
          <a-form-item>

            <a-range-picker
            format="YYYY-MM-DD HH:mm:ss"
            :showTime="{
              hideDisabledOptions: true,
              defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('00:00:00', 'HH:mm:ss')]
            }"
            v-decorator="['range']"
            :placeholder="['请选择开始时间', '请选择结束时间']"/>

          </a-form-item>

          <a-form-item>
            <a-button @click="handCancel">
              重置
            </a-button>
          </a-form-item>
          
          <a-form-item>
            <a-button type="primary" html-type="submit">
              查询
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <!-- 操作栏 -->
      <div class="handle">
        <a-button @click="onExport('?module=pc_api&action=User&m=userList&pageto=')">导出</a-button>
      </div>

      <!-- 表格 -->
      <div id="tableHeight">
		  <a-table v-if="tableHeight>0" :scroll="{ x: 1220, y: tableHeight }" :columns="columns" :dataSource="dataSource" :loading="loading" :pagination="pagination" @change="onChange">
		  
		    <span slot="action" slot-scope="text,record">
		      <template v-for="(item,i) in actionlist.action">
		        <a-button :type="item.style.type" :icon="item.style.icon"  :size="item.style.size" :key="i" @click="onCallback(item.callback,{ text, record })">{{ item.name }}</a-button>
		        <a-divider v-if="isDividerShow(i,actionlist.action)" type="vertical" />
		      </template>
		    </span>
		  
		  </a-table>
	  </div>
    </a-card>

    <!-- 今日足迹 -->
    <a-modal title="今日足迹" v-model="visible" :footer="null" @cancel="handtrcancal">
      <div style="height:506px;overflow: overlay;padding:10px 0px;" @scroll="onScroll($event)">
        <a-timeline>
          <template v-if="usertrack.length">
          <a-timeline-item v-for="(item,i) in usertrack" :key="i">{{ item.add_time }} {{ item.event }}</a-timeline-item>
          </template>
          <a-empty v-else />
        </a-timeline>
      </div>
    </a-modal>

    <!-- 导出 -->
    <a-modal v-model="visible1" title="导出数据" :footer="null" width="540px">
      <div class="derive">
        <div @click="onDownload('This_page')">
          <a-icon type="file-text" style="font-size:26px;" />
          <div>导出本页</div>
        </div>

        <div @click="onDownload('whole')">
          <a-icon type="snippets" style="font-size:26px;" />
          <div>导出全部</div>
        </div>

        <div @click="onDownload('inquiry')">
          <a-icon type="file-search" style="font-size:26px;" />
          <div>导出查询</div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title:'用户ID',
    key:'user_id',
    dataIndex:'user_id',
    width: 160
  },
  {
    title:'用户名称',
    key:'user_name',
    dataIndex:'user_name',
    width: 220
  },
  {
    title:'手机号',
    key:'mobile',
    dataIndex:'mobile',
    width: 150
  },
  {
    title:'备注',
    key:'event',
    dataIndex:'event',
    width: 300
  },
  {
    title:'时间',
    key:'add_time',
    dataIndex:'add_time',
    width: 170
  },
  {
    title:'操作',
    key:'action',
    scopedSlots: { customRender:'action' },
	width: 220,
	fixed: "right",
    action:[
      {
        type:'button',
        name:'今日足迹',
        style: {
          size:'small',
          icon:'',
          type:''
        },
        callback:function(text,record){
          this.visible = true
          this.getTrack({ user_id0: record.user_id })
        }
      },
      {
        type:'button',
        name:'删除',
        style: {
          size:'small',
          icon:'',
          type:''
        },
        callback:function(text,record){
          this.$confirm({
            title: '删除',
            content: '确认要删除此用户吗？',
            okText: '确认',
            okType: 'danger',
            cancelText: '取消',
            onOk:() => {
              this.delUserTrack({ user_id_browse: record.user_id })
            }
          })
        }
      }
    ]
  }
]

import moment from "moment"
export default {
  data(){
    return {
      loading: true,
      columns,
      usertrack: [],
      dataSource: [],
      actionlist: {},
      visible: false,
      form: this.$form.createForm(this, { name: "query_form" }),
      visible1: false,
      urls:'',
      pagination: {},
	  
	  searchData: {},
	  tableHeight: 0
    }
  },
  mounted(){
    let result = this.getActionList()
    if(result.length){
      this.actionlist = {...result[0]}
    }
    this.initOrder()
	
  },
  methods: {
	  getTableHeight(){
		  if(this.tableHeight == 0){
			if(document.getElementById('tableHeight')){
				this.tableHeight = document.getElementById('tableHeight').clientHeight-120
			}
			if(this.tableHeight<=0){
				this.tableHeight = 300
			}
		  }
	  },
    moment,
    onExport(url){
      this.visible1 = !this.visible1
      this.urls = url
    },
    onChange(pagination){
		pagination.page = pagination.current
		this.initOrder({ ...pagination,...this.searchData })
    },
    handtrcancal(){},
    handCancel() {
      this.form.resetFields();
    },
    /**
     * @name 查询
     */
    handleQuerySubmit(e){
      e.preventDefault()

      this.form.validateFields((err, values) => {
        if (!err) {
          let startdate
          let enddate
          let { mobile, range } = values

          if (range) {
            // 开始时间
            startdate = range[0].format("YYYY-MM-DD HH:mm:ss");
            // 结束时间
            enddate = range[1].format("YYYY-MM-DD HH:mm:ss");
          }
          let data = { mobile, enddate, startdate }
		  
		  this.searchData = data
          this.initOrder(data)
        }
      })
    },
    /**
     * @name 初始化页面数据
     */
    initOrder(datas = {}) {
      this.loading = true;
	  
      this.$request
        .post("?module=pc_api&action=User&m=userList",datas)
        .then(res => {
			this.getTableHeight();
          let { code, message, data } = res;
          if (code === 200) {

            Object.assign(this,{
              dataSource: data.list,
              pagination: { total: data.total,page: datas.current?datas.current:1,current: datas.current?datas.current:1 }
            })

          } else {
            this.$message.error(message);
          }

          setTimeout(() => {
            this.loading = false;
          }, 800)
        })
    },
    /**
     * @name 取操作列表
     * */ 
    getActionList(){
      return this.columns.filter(item =>item.key === 'action')
    },
    /**
     * @name 表格操作回调
     * */ 
    onCallback(callback,{ text, record }){
      callback.call(this,text,record)
    },
    /**
     * @name 操作分割线
     * */ 
    isDividerShow(i,list){
      i += 1
      if(list.length){
        return i != list.length
      }
    },
    /**
     * @name 今日足迹
     */
    getTrack(data,pages = 1){
		data.pages = pages
      this.$request.get('?module=pc_api&action=User&m=userPug',{ params:data }).then(res => {
        let { code, message, data } = res
        if(code === 200){
          Object.assign(this,{
            usertrack: data.list
          })
        }
      })
    },
    /**
     * @name 删除足迹
     */
    delUserTrack(data){
      this.$request.post('?module=pc_api&action=User&m=del',data).then(res => {
        let { code, message, data } = res
        if(code === 200){
          this.$message.success(message)
          this.initOrder()
        } else {
          this.$message.warning(message)
          this.initOrder()
        }
      })
    },
    onScroll(e){
      console.log(e.target.scrollTop)
    },
    /**
     * @name 导出
     */
    onDownload(pageto){
      if(pageto != 'whole'){
        this.form.validateFields((err, values) => {
          if (!err) {
            let startdate
            let enddate

            let { mobile, range } = values
            if (range) {
              // 开始时间
              startdate = range[0].format("YYYY-MM-DD HH:mm:ss");
              // 结束时间
              enddate   = range[1].format("YYYY-MM-DD HH:mm:ss");
            }

            let data = { startdate, enddate, mobile, page: this.pagination.page }
            this.$request.download(this.urls + pageto, data)
          }
        })
        return
      }
      
      this.$request.download(this.urls + pageto)
    }
  }
}
</script>

<style lang="less">
	.client_manage{
		height: 100%;
		
		.ant-card{
			display: flex;
			flex-direction: column;
			height: 100%;
			
			.ant-card-body{
				flex: 1;
				display: flex;
				flex-direction: column;
			}
			#tableHeight{
				flex: 1;
			}
		}
	}
	
	
.client_manage {
  .search {
    padding: 8px 32px;
  }

  .handle {
    padding: 0px 32px;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
  }
}

.derive {
  height: 200px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  > div {
    width: 100px;
    height: 100px;
    border: 1px solid #03a2f4;
    border-radius: 4px;
    color: #03a2f4;
    font-size: 14px;
    transition: background-color 0.5s;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    cursor: pointer;
  }

  > div:hover {
    border: 0px solid #03a2f4;
    color: #ffffff;
    background: #2890ff;
  }
}
</style>